import { atom } from 'jotai';

export interface AlertState {
  isOpen: boolean;
  type: string;
  message: string;
}

export const alertAtom = atom<AlertState>({
  isOpen: false,
  type: '',
  message: ''
});

export default alertAtom;
